import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { Row, Col, Table, Icon } from "antd";
import moment from "moment";

import ButtonStandard from "../../../../../../components/utils/button";
import { numberMask } from "../../../../../../services/helpersMethodsService";
import { getAnimalPicketHistory } from "../../../../../../services/animalHistoryService";
import { logEventError } from "../../../../../../utils/logger";

function TabAnimalPicketHistory() {
  const [loading, setLoading] = useState(false);
  const [picketHistoryData, setPicketHistoryData] = useState([]);

  const {
    app: {
      translation,
      groupSelected: { id: groupId },
      farmSelected: { id: farmId },
    },
  } = useSelector((state) => state);

  const {
    params: { id: animalId },
  } = useRouteMatch();

  const columns = [
    {
      title: translation.animal.details.animalHistory.picketName,
      width: 140,
      dataIndex: "picketName",
      key: "picketName",
      render: (text) => text || "-",
    },
    {
      title: translation.animal.details.animalHistory.lotName,
      width: 140,
      dataIndex: "lotName",
      key: "lotName",
      render: (text) => text || "-",
    },
    {
      title: translation.animal.details.animalHistory.entryDate,
      width: 120,
      dataIndex: "picketDateIn",
      key: "picketDateIn",
      render: (date) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: translation.animal.details.animalHistory.exitDate,
      width: 120,
      dataIndex: "picketDateOut",
      key: "picketDateOut",
      render: (date) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: translation.animal.details.animalHistory.daysQuantity,
      width: 100,
      dataIndex: "amountDays",
      key: "amountDays",
      render: (days) => `${days} dias` || "-",
    },
  ];

  const fetchPicketHistory = async () => {
    setLoading(true);
    try {
      const response = await getAnimalPicketHistory({
        groupId,
        farmId,
        animalId,
      });
      setPicketHistoryData(response.data.results);
    } catch (error) {
      logEventError("Erro ao buscar histórico de piquetes:", error);
      setPicketHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPicketHistory();
  }, [groupId, farmId, animalId]);

  const handleRefresh = () => {
    fetchPicketHistory();
  };

  return (
    <div>
      <Row type="flex" justify="end" style={{ marginBottom: 16 }}>
        <Col>
          <ButtonStandard buttonType="secondary" onClick={handleRefresh}>
            <Icon type="reload" /> {translation.buttons.updateTable}
          </ButtonStandard>
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={picketHistoryData}
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} de ${total} itens`,
          hideOnSinglePage:
            picketHistoryData !== null && picketHistoryData.length > 10
              ? false
              : true,
        }}
        scroll={{ x: true }}
      />
    </div>
  );
}

export default TabAnimalPicketHistory;
